/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import {SpoDetailService} from '../../../api/ms-specialorders/specialorder/spo-detail.service';
import {Observable} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {SpecialOrderDetailModel} from '../../../api/ms-specialorders/contracts/special-order-detail.model';
import {LoadingService} from '../../../shared/loading/loading-service/loading.service';

@Injectable({
    providedIn: 'root'
})
export class SpoDetailResolver  {

    constructor(private spoDetailService: SpoDetailService, private loadingService: LoadingService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<SpecialOrderDetailModel> {
        this.loadingService.start();
        const spoNumber = route.params['sponumber'];
        return this.spoDetailService.getSpecialOrderDetail(spoNumber).pipe(
            finalize(() => this.loadingService.stop())
        );
    }
}
